import { create } from 'zustand';
import { User, UserRole, Permission } from '@/lib/types';

type IUserStore = {
  user_id: string | null;
  user: User | null;
  isAuthenticated: boolean;
  role: UserRole | null;
  permissions: Permission[];
  setuser_id: (id: string) => void;
  setUser: (user: User) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setRole: (role: UserRole) => void;
  setPermissions: (permissions: Permission[]) => void;
  hasPermission: (permission: Permission) => boolean;
  hasRole: (role: UserRole) => boolean;
  logout: () => void;
  dashboardMode: 'overview' | 'real-estate' | 'crypto';
  setDashboardMode: (mode: 'overview' | 'real-estate' | 'crypto') => void;
};

const useUserStore = create<IUserStore>((set, get) => ({
  user_id: null,
  user: null,
  isAuthenticated: false,
  role: null,
  permissions: [],
  dashboardMode: 'overview',
  setDashboardMode: (mode) => set({ dashboardMode: mode }),
  setuser_id: (id) => set({ user_id: id }),
  setUser: (user) => set({
    user,
    user_id: user.id,
    isAuthenticated: true,
    role: user.role,
    permissions: user.permissions
  }),
  setIsAuthenticated: (isAuthenticated) => {
    if (!isAuthenticated) {
      // When clearing auth, also clear user data
      set({
        isAuthenticated: false,
        user_id: null,
        user: null,
        role: null,
        permissions: []
      });
    } else {
      set({ isAuthenticated });
    }
  },
  setRole: (role) => set({ role }),
  setPermissions: (permissions) => set({ permissions }),
  hasPermission: (permission) => get().permissions.includes(permission),
  hasRole: (role) => get().role === role,
  logout: () => set({
    user_id: null,
    user: null,
    isAuthenticated: false,
    role: null,
    permissions: []
  }),
}));

export default useUserStore;
